import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ContainerLogBookController } from './container-log-book.controller';
import { ContainerLogBook } from './container-log-book.entity';
import { ContainerLogBookService } from './container-log-book.service';
import { ContainerLogBookAdapter } from './repository/container-log-book.adapter';

@Module({
  imports: [
    TypeOrmModule.forFeature([ContainerLogBook]),
  ],
  controllers: [ContainerLogBookController],
  providers: [ContainerLogBookService,ContainerLogBookAdapter,ApplicationExceptionHandler]
})
export class ContainerLogBookModule {}
